import { render, staticRenderFns } from "./essay_page_header.vue?vue&type=template&id=84dee294&scoped=true&"
import script from "./essay_page_header.vue?vue&type=script&lang=js&"
export * from "./essay_page_header.vue?vue&type=script&lang=js&"
import style0 from "./essay_page_header.vue?vue&type=style&index=0&id=84dee294&prod&lang=scss&scoped=true&"
import style1 from "./essay_page_header.vue?vue&type=style&index=1&id=84dee294&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dee294",
  null
  
)

export default component.exports